<template>
  <ManuelContent src="/MANUEL_ADMIN.md" />
</template>

<script>
import ManuelContent from '@/components/ManuelContent.vue'

export default {
  name: 'AdminManuelView',
  components: { ManuelContent },
}
</script>
